
export const getBackgroundColour = (item, defaultValue = 'transparent') => {
    return getColour(item, "backColour", defaultValue);
}

export const getTextColour = (item, defaultValue = 'inherit') => {
    return getColour(item, "foreColour", defaultValue);
}

export const getColour = (item, key, defaultValue) => {
    return (item && item[key] && !item[key].isEmpty) ? `rgb(${item[key].r},${item[key].g},${item[key].b},${item[key].a})` : defaultValue;
}